import {makeAutoObservable, observable, runInAction} from "mobx";
import {injectable, inject} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {
	IContextualPromptBannerProvider,
	IPrompt,
} from "data/providers/contextual_prompt_banner/contextual_prompt_banner.provider";
import {ContextualProjects} from "data/enums";

export interface IContextualPromptBannerStore {
	get promptContent(): IPrompt[];
	check: (uid: string) => Promise<void>;
	decline: (uid: string) => Promise<void>;
	close: () => void;
	remove: (game: ContextualProjects) => void;
}

@injectable()
export class ContextualPromptBannerStore implements IContextualPromptBannerStore {
	@observable private _promptContent: IPrompt[] = [];
	constructor(
		@inject(Bindings.ContextualPromptBannerProvider)
		private _contextualPromptBannerProvider: IContextualPromptBannerProvider
	) {
		makeAutoObservable(this);
	}

	get promptContent() {
		return this._promptContent;
	}

	async check(uid: string = "") {
		if (!uid?.length) {
			return;
		}
		const response = await this._contextualPromptBannerProvider.check(uid);
		if (!response) {
			return;
		}
		runInAction(() => {
			if (response.data.success.prompt) {
				this._promptContent = [response.data.success.prompt];
			}
		});
	}

	async decline(uid: string) {
		await this._contextualPromptBannerProvider.user_decline(uid);
	}

	close = () => {
		this._promptContent = [];
	};

	remove = (game: ContextualProjects) => {
		this._promptContent = this._promptContent.filter((prompt) => prompt.game !== game);
	};
}
